import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Upload, FileText, CheckCircle, AlertCircle, Briefcase, MapPin, DollarSign } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
export function JobApplicationPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    currentPosition: '',
    yearsExperience: '',
    expectedSalary: '',
    availableDate: '',
    coverLetter: '',
    resume: null as File | null,
    portfolio: ''
  });
  const job = {
    id: 1,
    title: 'Senior Backend Developer',
    company: 'PT Teknologi Indonesia',
    location: 'Jakarta, Indonesia',
    type: 'Full-time',
    salary: 'Rp 15 juta - Rp 20 juta'
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      // Submit application
      alert('Lamaran berhasil dikirim!');
      navigate('/jobs');
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFormData({
        ...formData,
        resume: e.target.files[0]
      });
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-3335">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3336">
        {/* Header */}
        <div className="mb-8" data-id="element-3337">
          <Button variant="ghost" onClick={() => navigate(`/jobs/${id}`)} className="mb-4" data-id="element-3338">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-3339" />
            Kembali ke Detail Lowongan
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-3340">
            Lamar Pekerjaan
          </h1>
          <p className="text-neutral-600" data-id="element-3341">
            Lengkapi formulir di bawah untuk melamar posisi ini
          </p>
        </div>

        {/* Job Info */}
        <Card className="mb-8" data-id="element-3342">
          <CardContent className="p-6" data-id="element-3343">
            <div className="flex items-start gap-4" data-id="element-3344">
              <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-3345">
                <Briefcase className="w-6 h-6 text-atios-primary" data-id="element-3346" />
              </div>
              <div className="flex-1" data-id="element-3347">
                <h3 className="text-lg font-semibold text-neutral-900 mb-1" data-id="element-3348">
                  {job.title}
                </h3>
                <p className="text-atios-primary font-medium mb-2" data-id="element-3349">
                  {job.company}
                </p>
                <div className="flex flex-wrap gap-3 text-sm text-neutral-600" data-id="element-3350">
                  <span className="flex items-center gap-1" data-id="element-3351">
                    <MapPin className="w-4 h-4" data-id="element-3352" />
                    {job.location}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-3353">
                    <DollarSign className="w-4 h-4" data-id="element-3354" />
                    {job.salary}
                  </span>
                  <Badge variant="default" data-id="element-3355">{job.type}</Badge>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Progress Steps */}
        <div className="mb-8" data-id="element-3356">
          <div className="flex items-center justify-between" data-id="element-3357">
            {[1, 2, 3].map(s => <div key={s} className="flex items-center flex-1" data-id="element-3358">
                <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 ${step >= s ? 'bg-atios-primary border-atios-primary text-white' : 'bg-white border-neutral-300 text-neutral-400'}`} data-id="element-3359">
                  {step > s ? <CheckCircle className="w-5 h-5" data-id="element-3360" /> : <span className="font-semibold" data-id="element-3361">{s}</span>}
                </div>
                {s < 3 && <div className={`flex-1 h-1 mx-2 ${step > s ? 'bg-atios-primary' : 'bg-neutral-200'}`} data-id="element-3362" />}
              </div>)}
          </div>
          <div className="flex justify-between mt-2" data-id="element-3363">
            <span className="text-xs text-neutral-600" data-id="element-3364">Data Pribadi</span>
            <span className="text-xs text-neutral-600" data-id="element-3365">Pengalaman</span>
            <span className="text-xs text-neutral-600" data-id="element-3366">Dokumen</span>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} data-id="element-3367">
          <Card data-id="element-3368">
            <CardHeader data-id="element-3369">
              <CardTitle data-id="element-3370">
                {step === 1 && 'Data Pribadi'}
                {step === 2 && 'Pengalaman & Ekspektasi'}
                {step === 3 && 'Dokumen Pendukung'}
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6" data-id="element-3371">
              {/* Step 1: Personal Data */}
              {step === 1 && <>
                  <Input label="Nama Lengkap" required value={formData.fullName} onChange={e => setFormData({
                ...formData,
                fullName: e.target.value
              })} placeholder="John Doe" data-id="element-3372" />
                  <Input label="Email" type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} placeholder="john@example.com" data-id="element-3373" />
                  <Input label="Nomor Telepon" type="tel" required value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} placeholder="+62 812 3456 7890" data-id="element-3374" />
                </>}

              {/* Step 2: Experience */}
              {step === 2 && <>
                  <Input label="Posisi Saat Ini" required value={formData.currentPosition} onChange={e => setFormData({
                ...formData,
                currentPosition: e.target.value
              })} placeholder="Backend Developer" data-id="element-3375" />
                  <Input label="Pengalaman Kerja (tahun)" type="number" required value={formData.yearsExperience} onChange={e => setFormData({
                ...formData,
                yearsExperience: e.target.value
              })} placeholder="5" data-id="element-3376" />
                  <Input label="Ekspektasi Gaji (per bulan)" required value={formData.expectedSalary} onChange={e => setFormData({
                ...formData,
                expectedSalary: e.target.value
              })} placeholder="Rp 15.000.000" data-id="element-3377" />
                  <Input label="Tanggal Dapat Mulai" type="date" required value={formData.availableDate} onChange={e => setFormData({
                ...formData,
                availableDate: e.target.value
              })} data-id="element-3378" />
                  <div data-id="element-3379">
                    <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-3380">
                      Cover Letter
                    </label>
                    <textarea required value={formData.coverLetter} onChange={e => setFormData({
                  ...formData,
                  coverLetter: e.target.value
                })} className="w-full min-h-[150px] rounded-lg border border-neutral-300 bg-white px-4 py-3 text-sm text-neutral-900 placeholder:text-neutral-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" placeholder="Ceritakan mengapa Anda tertarik dengan posisi ini dan apa yang membuat Anda cocok..." data-id="element-3381" />
                  </div>
                </>}

              {/* Step 3: Documents */}
              {step === 3 && <>
                  <div data-id="element-3382">
                    <label className="text-sm font-medium text-neutral-900 block mb-2" data-id="element-3383">
                      Upload CV/Resume (PDF, max 5MB)
                    </label>
                    <div className="border-2 border-dashed border-neutral-300 rounded-lg p-8 text-center hover:border-atios-primary transition-colors" data-id="element-3384">
                      <input type="file" accept=".pdf" onChange={handleFileChange} className="hidden" id="resume-upload" required data-id="element-3385" />
                      <label htmlFor="resume-upload" className="cursor-pointer" data-id="element-3386">
                        <Upload className="w-12 h-12 text-neutral-400 mx-auto mb-4" data-id="element-3387" />
                        <p className="text-sm text-neutral-600 mb-2" data-id="element-3388">
                          {formData.resume ? formData.resume.name : 'Klik untuk upload CV/Resume'}
                        </p>
                        <p className="text-xs text-neutral-500" data-id="element-3389">
                          PDF, maksimal 5MB
                        </p>
                      </label>
                    </div>
                  </div>
                  <Input label="Link Portfolio/LinkedIn (opsional)" value={formData.portfolio} onChange={e => setFormData({
                ...formData,
                portfolio: e.target.value
              })} placeholder="https://linkedin.com/in/johndoe" data-id="element-3390" />
                  <div className="bg-atios-light border border-atios-primary/20 rounded-lg p-4" data-id="element-3391">
                    <div className="flex gap-3" data-id="element-3392">
                      <AlertCircle className="w-5 h-5 text-atios-primary flex-shrink-0 mt-0.5" data-id="element-3393" />
                      <div className="text-sm text-neutral-700" data-id="element-3394">
                        <p className="font-medium mb-1" data-id="element-3395">Catatan Penting:</p>
                        <ul className="list-disc list-inside space-y-1 text-neutral-600" data-id="element-3396">
                          <li data-id="element-3397">Pastikan semua data yang Anda isi benar</li>
                          <li data-id="element-3398">CV harus dalam format PDF</li>
                          <li data-id="element-3399">Kami akan menghubungi Anda dalam 7 hari kerja</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </>}

              {/* Navigation Buttons */}
              <div className="flex justify-between pt-6 border-t border-neutral-200" data-id="element-3400">
                {step > 1 && <Button type="button" variant="secondary" onClick={() => setStep(step - 1)} data-id="element-3401">
                    Sebelumnya
                  </Button>}
                <Button type="submit" className={step === 1 ? 'ml-auto' : ''} data-id="element-3402">
                  {step === 3 ? <>
                      <FileText className="w-4 h-4 mr-2" data-id="element-3403" />
                      Kirim Lamaran
                    </> : 'Selanjutnya'}
                </Button>
              </div>
            </CardContent>
          </Card>
        </form>
      </div>
    </div>;
}